import { PaymentMethod } from 'types';
import { baseQuery } from '../baseQuery';

type PostInvoiceParams = {
  serviceId: number;
  paymentMethod: PaymentMethod;
};

export const postServiceInvoice = async ({ serviceId, paymentMethod }: PostInvoiceParams) => {
  const { data } = await baseQuery('service-invoice', {
    type: 'POST',
    body: {
      payment_method: paymentMethod,
      service_id: serviceId,
    },
  });

  return data as never[];
};
